import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  // Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import {
  BarChart as BarChartIcon,
  Home as HomeIcon,
  Settings as SettingsIcon,
  User as UserIcon,
  List as ReportsIcon,
  Users as UsersIcon,
  Upload as UploadIcon,
  Award as AwardIcon,
  Book as AssessmentIcon
} from 'react-feather';
import NavItem from './NavItem';

const adminItems = [
  {
    href: '/app/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  {
    href: '/app/clients',
    icon: AwardIcon,
    title: 'Clients'
  },
  {
    href: '/app/users',
    icon: UsersIcon,
    title: 'Users'
  },
  {
    href: '/app/tasks',
    icon: AssessmentIcon,
    title: 'Assessments'
  },
  {
    href: '/app/onboarding',
    icon: UploadIcon,
    title: 'Onboarding'
  },
  // {
  //   href: '/app/tasks',
  //   icon: ThermometerIcon,
  //   title: 'Assessment Status'
  // },
  {
    href: '/app/reports',
    icon: ReportsIcon,
    title: 'Reports'
  },
  {
    href: '/app/account',
    icon: UserIcon,
    title: 'Account'
  },
  {
    href: '/app/logout',
    icon: SettingsIcon,
    title: 'Logout'
  }
];

const restrictedItems = [
  {
    href: '/app/home',
    icon: HomeIcon,
    title: 'Home'
  },
  {
    href: '/app/logout',
    icon: SettingsIcon,
    title: 'Logout'
  }
];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const userInfoState = useSelector((state) => state.user.currentUser);
  const [user, setUser] = useState({
    name: '',
    jobTitle: '',
    avatar: '/static/images/avatars/avatar.png'
  });
  const location = useLocation();

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (userInfoState) {
      setUser({
        avatar: '/static/images/avatars/avatar.png',
        name: userInfoState.first_name,
        jobTitle: userInfoState.designation
      });
    }
  }, [userInfoState]);

  const userClientId = Number(
    userInfoState?.clientId ?? userInfoState?.client_id ?? 0
  );
  const isRestrictedUser = !!userInfoState && userClientId !== 3;
  const items = isRestrictedUser ? restrictedItems : adminItems;

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 2
        }}
      >
        <Avatar
          component={RouterLink}
          src={user.avatar}
          sx={{
            cursor: 'pointer',
            width: 64,
            height: 64
          }}
          to="/app/account"
        />
        <Typography color="textPrimary" variant="h5">
          {user.name}
        </Typography>
        {/* <Typography color="textSecondary" variant="body2">
          {user.jobTitle}
        </Typography> */}
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      {/* <Box
        sx={{
          backgroundColor: 'background.default',
          m: 2,
          p: 2
        }}
      >
        <Typography
          align="center"
          gutterBottom
          variant="h4"
        >
          Need more?
        </Typography>
        <Typography
          align="center"
          variant="body2"
        >
          Upgrade to PRO version and access 20 more screens
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 2
          }}
        >
          <Button
            color="primary"
            component="a"
            href="https://react-material-kit.devias.io"
            variant="contained"
          >
            See PRO version
          </Button>
        </Box>
      </Box> */}
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 56,
              height: 'calc(100% - 56px)'
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default DashboardSidebar;
